import {
  PhoneCall,
  FileText,
  MessageSquare,
  ArrowRight,
  BookOpen,
} from "lucide-react";
import { Card, Button } from "antd";
import "./StudentTools.css";

export const StudentTools = ({ data = {} }) => {
  const tools = [
    {
      title: "Compare Colleges",
      description: "Compare Stanford with other universities side by side",
      icon: "BookOpen",
    },
    {
      title: "Book Advisor Call",
      description: "Schedule a call with our education advisors",
      icon: "PhoneCall",
    },
    {
      title: "SOP/LOR Generator",
      description: "Create personalized application documents",
      icon: "FileText",
    },
    {
      title: "Join Community",
      description: "Connect with current students and alumni",
      icon: "MessageSquare",
    },
  ];

  const requiredDocuments = [
    "Application Form",
    "Academic Transcripts",
    "Standardized Test Scores",
    "Statement of Purpose",
    "Letters of Recommendation",
  ];

  const iconMap = {
    BookOpen: BookOpen,
    PhoneCall: PhoneCall,
    FileText: FileText,
    MessageSquare: MessageSquare,
  };

  return (
    <Card className="student-tools-card">
      <div className="student-tools-header">
        <h2 className="student-tools-title">Student Tools</h2>
      </div>
      <div className="student-tools-content">
        <Button className="applyButton">
          Apply Now
          <ArrowRight className="button-icon" />
        </Button>

        <div className="tools-grid">
          {tools.map((tool, index) => {
            const IconComponent = iconMap[tool.icon] || BookOpen;
            return (
              <div key={index} className="tool-item">
                <div className="tool-header">
                  <div className="icon-container">
                    <IconComponent className="icon" />
                  </div>
                  <div>
                    <h3 className="tool-title">{tool.title}</h3>
                  </div>
                </div>
                <p className="tool-description">{tool.description}</p>
              </div>
            );
          })}
        </div>

        {/* <div className="deadlines-section">
          <h3 className="section-title">Application Deadlines</h3>
          <div className="deadlines-list">
            {applicationDeadlines.map((deadline, index) => (
              <div key={index} className="deadline-item">
                <span className="deadline-type">{deadline.type}</span>
                <span className="deadline-date">{deadline.date}</span>
              </div>
            ))}
          </div>
        </div> */}

        <div className="documents-section">
          <h3 className="section-title">Required Documents</h3>
          <ul className="documents-list">
            {requiredDocuments.map((doc, index) => (
              <li key={index} className="document-item">
                <div className="bullet-point"></div>
                {doc}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Card>
  );
};
